import styled from 'styled-components';

export const AccordionContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const AccordionHeader = styled.button<{ $isOpen: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(36, 42, 51, 0.85)'
    : 'rgba(255, 255, 255, 0.85)')};
  backdrop-filter: blur(12px);
  border: 1px solid ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(55, 65, 81, 0.5)'
    : 'rgba(226, 232, 240, 0.5)')};
  border-bottom: ${({ $isOpen, theme }) => ($isOpen
    ? 'none'
    : `1px solid ${theme.mode === 'dark' ? 'rgba(55, 65, 81, 0.5)' : 'rgba(226, 232, 240, 0.5)'}`)};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(46, 52, 61, 0.95)'
    : 'rgba(248, 250, 252, 0.95)')};
  }
`;

export const AccordionTitle = styled.h3`
  font-size: 16px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const AccordionIcon = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const AccordionContent = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(36, 42, 51, 0.85)'
    : 'rgba(255, 255, 255, 0.85)')};
  backdrop-filter: blur(12px);
  border-left: 1px solid ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(55, 65, 81, 0.5)'
    : 'rgba(226, 232, 240, 0.5)')};
  border-right: 1px solid ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(55, 65, 81, 0.5)'
    : 'rgba(226, 232, 240, 0.5)')};
  border-bottom: 1px solid ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(55, 65, 81, 0.5)'
    : 'rgba(226, 232, 240, 0.5)')};
`;

export const AccordionContentInner = styled.div`
  padding: 20px;
`;
